module.exports = __webpack_public_path__ + "img/active_left.992b668f.png";